import { Injectable, signal } from '@angular/core';

export type LoaderMessage = 'analyzing' | 'uploading' | 'translating' | 'fixingMap' | null;

@Injectable({ providedIn: 'root' })
export class LoaderMessageService {
  readonly message = signal<LoaderMessage>(null);
  readonly mapProgress = signal<string | null>(null);
  readonly cancelMap = signal<(() => void) | null>(null);

  set(message: LoaderMessage): void {
    this.message.set(message);
  }
}
